import templateUrl from './archivedMetricsWarningIcon.tpl.html';

export const archivedMetricsWarningIcon = {
    templateUrl,
    bindings: {},
    controller: [function () {}],
};
